/**
 * A step, named for a reader rather than for the workflow file.
 *
 * Runs and results carry the step's *id* — `run_check`, `$start` — because the
 * id is what survives a rename and a deleted step. Nobody reading a task wants
 * the id. The board knows every current step's label, so that comes first; a
 * file change records the step's name at the time, which covers a step since
 * renamed or removed; and failing both, the id is turned into words rather
 * than shown raw, so `run_check` reads "Run check" and `$start` reads "Start".
 */
export function humaniseStepId(stepId: string): string {
  const words = stepId
    .replace(/^\$/, '')
    .split(/[_\-\s]+/)
    .filter((word) => word.length > 0);
  const [first, ...rest] = words;
  if (!first) return stepId;
  return [first.charAt(0).toUpperCase() + first.slice(1), ...rest].join(' ');
}

export function stepDisplayName(
  stepId: string,
  labels?: ReadonlyMap<string, string>,
  recordedName?: string | null,
): string {
  const known = labels?.get(stepId);
  if (known) return known;
  const recorded = recordedName?.trim();
  if (recorded) return recorded;
  return humaniseStepId(stepId);
}
